import { createFileRoute } from "@tanstack/react-router";

import { CashbookPage } from "../../../features/accounting/cashbook-page";

export const Route = createFileRoute("/_app/accounting/cashbook")({ component: CashbookPage });
